// @flow
import { entityReducer } from "src/utils/reducerUtils";
import TrendModel from "src/models/TrendModel";

export const patientTrends = entityReducer({
  name: "patientTrends",
  Model: TrendModel
});
